<ag-grid-angular [showSpinner]="isLoading" class="entity-list ag-theme-material" [ngStyle]="gridSizes"
                 rowSelection="single" suppressCellSelection="true" [columnDefs]="columnDefs"
                 [defaultColDef]="defaultColDef"
                 (gridReady)="onGridReady($event)" suppressHorizontalScroll="true" [rowData]="rowData"
                 (modelUpdated)="onGridReady($event)" [frameworkComponents]="frameworkComponents"
                 [overlayLoadingTemplate]="'&nbsp;'"
                 [sortingOrder]="['asc','desc']" [rowClassRules]="rowClassRules" [cacheBlockSize]="numberOfRawsInPage"
                 [context]="context" [icons]="icons" rowModelType="infinite" [debug]="debugGrid" [rowHeight]="rowHeight"
                 [headerHeight]="headerHeight" (sortChanged)="onSortChange($event)" (dragStopped)="onColDragEnd($event)"
                 [rowClass]="rowClass"
                 (viewportChanged)="onViewPortChanges($event)" (bodyScroll)="bodyScroll($event)"
                 (columnResized)="onColumnResized($event)">
</ag-grid-angular>
